import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { ListPanelModule } from 'src/app/bloom/specialized-panels/list-panel/list-panel.module';
import { SpinnerModule } from '../spinner/spinner.module';
import { AttributeSelectionModule } from '../query-components/attribute-selection/attribute-selection.module';
import { MatCardModule } from '@angular/material/card';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatCheckboxModule} from '@angular/material/checkbox';

@Component({
    selector: 'app-collect-action-data',
    imports: [
        MatTooltipModule,
        MatExpansionModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatChipsModule,
        FlexLayoutModule,
        CommonModule,
        FormsModule,
        ListPanelModule,
        SpinnerModule,
        AttributeSelectionModule,
        MatCardModule,
        MatSelectModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatCheckboxModule
    ],
    templateUrl: './collect-action-data.component.html',
    styleUrl: './collect-action-data.component.scss'
})
export class CollectActionDataComponent implements OnInit {
  @Input() action: any;
  @Input() boxObjectAttributes: any;
  @Output() constructedData = new EventEmitter<any>();

  cutomAttribute: any = {__id: "", dataType: "string"}
  isCreateCustomAttribute: boolean = false;
  inputList: any = [];
  recordList: any = [];
  customRecord: any = [];
  attributeControl = new FormControl([]);
  selectedAttributes: any[] = [];
  availableBoxTypes: string[] = ["string", "number", "date", "datetime", "boolean", "array", "object"];

  ngOnInit(): void {
    this.inputList = this.boxObjectAttributes.filter((attr) => attr.required);
    this.recordList.push(this.initializeFormData(this.inputList));

    const requiredAttributes = this.boxObjectAttributes.filter(
      (attr) => attr.required
    );
    this.attributeControl.setValue(requiredAttributes);
    this.selectedAttributes = [...requiredAttributes];

    this.attributeControl.valueChanges.subscribe((selectedValues: any[]) => {
      this.selectedAttributes = selectedValues;
      this.onAttributeSelectionChange();
    });
  }

  trackByFn(index:number, item:any):any{
    return item || index
  }

  initializeFormData(list: any[]): any {
    let formData = {};
    list.forEach((item) => {
      formData[item.__id] = '';
    });
    return formData;
  }

  trackChanges(): void {
    this.constructedData.emit(this.recordList);
  }

  onAttributeSelectionChange() {
    this.inputList = this.selectedAttributes;
    this.columnSelectionChanged(this.inputList);
  }

  columnSelectionChanged(event: any): void {
    if (!event) return;

    this.recordList = this.recordList.map((record) => {
      let updatedRecord = {};
      event.forEach((item) => {
        updatedRecord[item.__id] = record[item.__id] || '';
      });
      return updatedRecord;
    });

    this.trackChanges();
  }

  isAttributeDisabled(attribute: any): boolean {
    return attribute.required === true || attribute.writable === false;
  }
  hasDisabledAttributes(): boolean {
    return this.boxObjectAttributes?.some(attr => this.isAttributeDisabled(attr));
  }

  remove(attribute: any): void {
    if (!this.isAttributeDisabled(attribute)) {
      this.selectedAttributes = this.selectedAttributes.filter(
        (attr) => attr !== attribute
      );
      this.attributeControl.setValue(this.selectedAttributes);
    }
  }

  addRecord(list: any[]): void {
    this.recordList.push(this.initializeFormData(list));
  }

  deleteRecord(index: number): void {
    if (this.recordList.length > 1) {
      this.recordList.splice(index, 1);
      this.trackChanges();
    }
  }

  onChangeOfAttributeName(event){
    this.cutomAttribute.name = this.cutomAttribute.__id;
  }

  addCustomAttribute(){
    if(!this.boxObjectAttributes) this.boxObjectAttributes = [];
    this.boxObjectAttributes.push(this.cutomAttribute);
  }


  deleteCustomRecord(index: number): void {
    this.customRecord.splice(index, 1);//delete the index
  }

  customAttributeInputAdded(e) {
    let record = {};
    // Iterate over the customRecord array to construct the record object
    for (let index = 0; index < this.customRecord.length; index++) {
        const element = this.customRecord[index];
        // Map each element's __id as the key and its value as the value
        if(['array', 'object'].includes(element?.dataType)) {record[element?.__id] = JSON.parse(element?.value) } else {
          record[element?.__id] = element?.value;
        }

    }
    this.constructedData.emit([record]);
  }

  onAttributeDataTypeSelected(data){
    if(data.dataType == "boolean") data.value = false; //setting default value for boolean
  }


  // add new attribute
  addNewAttribute(){
    this.customRecord.push({
      __id: "",
      dataType: "string",
      value: ""
    });
  }
}
